import React, { useEffect, useRef, useState, Fragment } from "react"
import { PiPrinter } from "react-icons/pi"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Button, } from "components"
import PrinterErrorModal from "./PrinterErrorModal"
import { createPrintRequest } from "utils"
import classes from "./PrinterTestButton.module.scss"

const PrinterTestButton = props => {
  const { form, categoryIds } = props

  const [t, i18n] = useTranslation()

  const [loading, setLoading] = useState(false)
  const [showErrorModal, setShowErrorModal] = useState(false)

  const unmount = useRef(false)

  const handleTest = async () => {
    setLoading(true)

    const printerSettings = { ...form, categoryIds }

    const request = {
      printData: null,
      printType: "test",
      printerSettings
    }

    try {
      await createPrintRequest(request)
    } catch (err) {
      console.log(err)

      if (unmount.current) return

      setShowErrorModal(true)
    }

    if (unmount.current) return

    setLoading(false)
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <Button
        color="info"
        loading={loading}
        onClick={handleTest}
        className={clsx(
          classes["test"],
          isLtr && classes["test-ltr"]
        )}
      >
        <PiPrinter
          color="white"
          size={18}
        />

        <span
          className={clsx(
            classes["test-text"],
            isLtr && classes["test-text-ltr"]
          )}
        >
          {t("تست_کردن")}
        </span>
      </Button>

      <PrinterErrorModal
        showErrorModal={showErrorModal}
        setShowErrorModal={setShowErrorModal}
        printerInterface={form.printerInterface}
      />
    </Fragment>
  )
}

export default PrinterTestButton